export default {
  __html: `<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
        <g id="07.8.2_Dados_Do_Plano_Pos_Pago_Debito" transform="translate(-285.000000, -845.000000)" stroke="#292663" stroke-width="2">
            <polyline id="Path-2-Copy-2" transform="translate(289.000000, 851.500000) rotate(-90.000000) translate(-289.000000, -851.500000) " points="284 849.054879 288.972409 854 294 849"></polyline>
        </g>
    </g>/>
`
}
